import { AlignType, EntityType, ResizeOptions } from "./enums";

export interface IEntity {
    /** Index of the entity within the array of components/links. */
    readonly index: number;
    /** Identifier of Picasso entity. */
    readonly id: string;
    readonly type: EntityType;
}

export interface IComponent extends IEntity {
    readonly isVisible: boolean;
    readonly children: readonly number[];
    readonly linkIndexes: readonly number[];
    readonly parent: number | null;
    readonly name: string;
    readonly width: number;
    readonly minWidth: number;
    readonly height: number;
    readonly resizeOption: ResizeOptions;
    readonly noCssHeight?: boolean;
    readonly noCssWidth?: boolean;
    readonly minHeight: number;
    readonly align: AlignType;
    readonly relativeTop: number;
    readonly relativeLeft: number;
}

export interface ILink extends IEntity {
    readonly name: string;
    readonly ownerIndex: number;
    readonly startComponentIndex: number;
    readonly endComponentIndex: number;
    readonly points: readonly IPoint[];
}

export interface IPoint {
    readonly x: number;
    readonly y: number;
}
